import React from 'react';

// Red de seguridad de cada pantalla: si una pantalla falla al dibujarse, el menú y el encabezado siguen y aquí se dice qué pasó, en vez de
// dejar todo en blanco. Se reinicia sola al cambiar de pantalla (resetKey). El detalle técnico queda en la consola.
export default class PageErrorBoundary extends React.Component {
  constructor(props) { super(props); this.state = { error: null }; }

  static getDerivedStateFromError(error) { return { error }; }

  componentDidCatch(error, info) { console.error('Una pantalla falló al dibujarse:', error, info?.componentStack); }

  componentDidUpdate(prev) { if (this.state.error && prev.resetKey !== this.props.resetKey) this.setState({ error: null }); }

  render() {
    if (!this.state.error) return this.props.children;
    return (
      <section role="alert" className="mx-auto max-w-xl rounded-3xl bg-panel ring-1 ring-line p-6 sm:p-8 text-center" style={{ boxShadow: 'var(--shadow)' }}>
        <h2 className="font-display text-[22px] font-bold text-fg">Esta pantalla tuvo un problema</h2>
        <p className="mt-2 text-[14px] text-fg-dim">No pudimos mostrarla. El resto del admin sigue funcionando: puedes volver a intentarlo o ir al inicio.</p>
        <p className="mt-3 break-words rounded-xl bg-raised px-3 py-2 text-left text-[12px] text-fg-faint font-mono">{String(this.state.error?.message || this.state.error).slice(0, 240)}</p>
        <div className="mt-5 flex flex-wrap justify-center gap-2">
          <button type="button" onClick={() => this.setState({ error: null })}
            className="h-10 px-5 rounded-full bg-raised text-fg ring-1 ring-inset ring-line text-[14px] font-semibold hover:ring-fg/20 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-live">
            Volver a intentar
          </button>
          <a href="/dashboard" className="inline-flex items-center h-10 px-5 rounded-full bg-fg text-ink text-[14px] font-semibold hover:bg-fg/85 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-live">Ir al inicio</a>
        </div>
      </section>
    );
  }
}
